import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest } from 'utilities/service.utils';
import LocateService from './locate.service.context';

export const getMailboxUnmatchedCount = async () => {
  const urlBuilder = createUrlBuilder('/mailboxes/unmatchedCount');
  const result = await getRequest(LocateService, urlBuilder.toString());
  return result;
};
